import createApi from "./createApi";
export * from "./types";

const api = createApi();

export default api;
